import { render, staticRenderFns } from "./RoleRightsSetting.vue?vue&type=template&id=21d2a80e&scoped=true"
import script from "./RoleRightsSetting.vue?vue&type=script&lang=js"
export * from "./RoleRightsSetting.vue?vue&type=script&lang=js"
import style0 from "./RoleRightsSetting.vue?vue&type=style&index=0&id=21d2a80e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21d2a80e",
  null
  
)

export default component.exports